import React, {useEffect, useState} from "react";
import {Table, Form, Input, Select, Button, Space, Card, Row, Col, Switch, message, Modal, Popconfirm} from "antd";
import {SearchOutlined, EditOutlined, DeleteOutlined} from "@ant-design/icons";
import styles from "./AppBillingManage.module.css";
import {LeftOutlined, RightOutlined} from '@ant-design/icons';

import {Pagination} from 'antd';

import CommonModal from './add/Common.js'
import EditCommonModal from './edit/Common.js'
import EditModal from './edit/Common.js'

import {getUserListRequest, delUserRequest, shouquanUserRequest, getUserInfoRequest} from "./api";
import { closeAdminPage, openLogin} from "../../../store/modalsSlice";
import settingIcon from "./setting.svg";
import {useDispatch} from "react-redux";
import InfoItem from "./InfoItem";
import { clearAllCookies } from "../../../util/handleObject.js";
import Cookies from 'js-cookie';
const {Option} = Select;

const AppBillingManage = () => {

    const dispatch = useDispatch();
    // 筛选表单状态
    const [filterForm, setFilterForm] = useState({
        name: "",
        status: ""
    });

    // 用户数据状态
    // const [users, setUsers] = useState([
    //   { id: 1, username: '李佳思', accountType: '普通用户', account: '15140715441', status: false, createTime: '2026-12-24 13:45:34' },
    //   { id: 2, username: '张闪闪', accountType: '普通用户', account: '15140715441', status: false, createTime: '2026-12-24 13:45:34' },
    //   // 添加更多空数据行作为示例
    //   ...Array(8).fill(null).map((_, i) => ({
    //     id: i + 3,
    //     username: '-',
    //     accountType: '-',
    //     account: '-',
    //     status: false,
    //     createTime: '-'
    //   }))
    // ]);
    const [users, setUsers] = useState([]);
    // 分页状态

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isShowEditCommon, setIsShowEditCommon] = useState(false);
    const [isShowEdit, setIsShowEdit] = useState(false);
    const [editUser, setEditUser] = useState({
        name: "",
    });
    const [totalNumber, setTotalNumber] = useState(0);
    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [nameKey, setNameKey] = useState('');
    const [status, setStatus] = useState('');
    const [currentPage, setCurrentPage] = useState(1);


    const [user, setUser] = useState({
        name: "",
        email: ""
    });

    useEffect(() => {
        getUserList(nameKey, status, offset, limit)
        getUserInfo(Cookies.get("username"))
    }, []); // 空数组意味着这个 effect 只会在组件挂载时执行一次


    function getUserInfo(username) {
        getUserInfoRequest(username, (data) => {
            console.log(data);
            if (data.ret === '1') {
                setUser(data.data)
            } else {
            }
        });
    }

    function getUserList(namekey, status, offset, limit) {
        getUserListRequest(namekey, status, offset, limit, (data) => {
            console.log(data);
            if (data.ret === '1') {
                setUsers(data.data.data)
                setTotalNumber(data.data.total_num)
            } else {
            }
        });
    }

    function deleteUser(username) {
        delUserRequest(username, (data) => {
            console.log(data);
            if (data.ret === '1') {
                message.success("删除成功", 1);
                getUserList(nameKey, status, offset, limit)
            } else {
            }
        });
    }

    function closeCommonModal() {
        setIsModalVisible(false)
        setIsShowEditCommon(false)
        setIsShowEdit(false)
    };

    function updateData() {
        getUserList(nameKey, status, offset, limit)
    }

    // 处理状态切换
    const handleStatusChange = (username, checked) => {

        var status = checked ? '1' : '3';

        shouquanUserRequest(username, status, (data) => {
            console.log(data);
            if (data.ret === '1') {
                setUsers(users.map(user =>
                    user.username === username ? {...user, status: checked} : user
                ));
            } else {
                message.error(data.msg, 1);
            }
        });


    };

    // 处理删除操作
    const handleDelete = (username, user_login) => {
        Modal.confirm({
            title: '确认删除',
            content: '确定要删除账号' + user_login + '吗？删除后不可恢复',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
                console.log('用户点击了确定');
                // 在这里调用删除API
                deleteUser(username)
            },
            onCancel() {
                console.log('用户点击了取消');
            },
        });
    };


    // 处理筛选表单变化
    const handleFilterChange = (name, value) => {
        setFilterForm({
            ...filterForm,
            [name]: value
        });
    };

    // 处理筛选提交
    const handleFilterSubmit = () => {
        // 这里应该是API调用，这里只是模拟
        console.log("筛选条件:", filterForm);
        // 实际项目中这里应该调用API获取筛选后的数据
        getUserList(filterForm.name, filterForm.status, offset, limit)

    };

    // 处理重置筛选
    const handleResetFilter = () => {
        setFilterForm({
            name: "",
            status: ""
        });
        // 重置后重新获取所有数据
    };

    const onShowSizeChange = (page, pageSize) => {
        //pageSize 变化的回调
        console.log(page, pageSize);
        setCurrentPage(1)
        setOffset(0)
        setLimit(pageSize)
    };

    const onChangePage = (current, pageSize) => {
        //页码或 pageSize 改变的回调，参数是改变后的页码及每页条数
        console.log(current, pageSize);
        setCurrentPage(current)
        getUserList(nameKey, status, (current - 1) * pageSize, pageSize)

    };


    return (

        <div className={styles.background}>

            <div className={styles.rightMenus}>
                <div className={styles["div-top"]}>
                    <h3 style={{marginLeft: 30}}>应用计费管理</h3>

                    <Popconfirm
                        placement="bottom"
                        title={""}
                        description={"是否退出登录"}
                        okText="是"
                        cancelText="否"
                        onConfirm={(e) => {
                            sessionStorage.clear()
                            clearAllCookies()
                            dispatch(closeAdminPage())
                            dispatch(openLogin())
                        }}
                    >
                        <div className={styles.iconContainer}>
                            <img src={settingIcon} style={{width: '20px', height: '20px'}}/>
                        </div>
                    </Popconfirm>

                    <Button
                        className={styles["bt-refresh"]}
                        type="primary"
                        onClick={handleFilterSubmit}
                    >
                        刷新
                    </Button>
                </div>


                <Card title="" className={styles["card-top"]}>

                    <div className={styles["div-shaixuan"]}>
                        <div>数据筛选</div>

                        <Space className={styles["bt-shaixuan2"]}>
                            <Button onClick={handleResetFilter}>重置</Button>
                            <Button
                                type="primary"
                                onClick={handleFilterSubmit}
                            >
                                查询
                            </Button>

                        </Space>

                    </div>
                    <Row gutter={24} align="middle">
                        <Col span={6}
                        >
                            <Row align="middle">
                                <Col flex="50px"
                                >
                                    关键字
                                </Col>
                                <Col
                                    // flex="auto"
                                    style={{width: "calc(100% - 50px)"}}
                                >
                                    <Input
                                        placeholder="关键字"
                                        value={filterForm.name}
                                        onChange={(e) => handleFilterChange("name", e.target.value)}
                                    />
                                </Col>
                            </Row>
                        </Col>
                        <Col

                        >
                            <Row align="middle">
                                <Col flex="40px"
                                >
                                    状态
                                </Col>
                                <Col
                                    // flex="auto"
                                    style={{width: "calc(100% - 50px)"}}
                                    justify="start"
                                >
                                    <Select
                                        placeholder="状态"
                                        value={filterForm.status}
                                        onChange={(value) => handleFilterChange("status", value)}
                                    >
                                        <Option value="">全部</Option>
                                        <Option value="1">正常</Option>
                                        <Option value="3">禁用</Option>
                                    </Select>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>

                <Card title="" className={styles["card-bottom"]}>
                    <div className={styles["container-list"]}>

                        <div className={styles["div-shaixuan"]}>
                            <div>数据列表</div>

                            <Button
                                style={{marginLeft: 'auto'}}
                                type="primary"
                                onClick={() => {
                                    setIsModalVisible(true)
                                }}
                            >
                                添加
                            </Button>

                        </div>


                        <div className={styles.tableContainer}>
                            <table className={styles.infoTable}>
                                <tr
                                    className={styles.tr1}
                                >
                                    <td
                                        className={styles.td1}
                                    >应用名称
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >计费规则
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >调用积分消耗量
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >用户积分消耗量
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >应用来源
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >状态
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >添加时间
                                    </td>
                                    <td
                                        className={styles.td2}
                                    >操作
                                    </td>
                                </tr>
                                {users.map((item, index) => (
                                    <InfoItem
                                        item={item}
                                        key={index + 1}
                                        index={index + 1}
                                        editMethod={(info) => {
                                            console.log(info)
                                            if(info.id % 2 == 0){
                                                setIsShowEditCommon(true)
                                            }
                                            else {
                                                setIsShowEdit(true)
                                            }
                                        }}
                                        deleteMethod={(info) => {
                                            alert('删除。。。')
                                        }}
                                    />
                                ))}
                            </table>

                            {/* 分页控件 - 右下角 */}

                        </div>
                        <Pagination
                            hideOnSinglePage={true}//只有一页隐藏分页器
                            align="end"
                            style={{marginTop: 20}}
                            showSizeChanger //是否展示 pageSize 切换器，当 total 大于 50 时默认为 true
                            onShowSizeChange={onShowSizeChange}//pageSize 变化的回调
                            defaultCurrent={1}
                            current={currentPage}
                            total={totalNumber}
                            locale={{
                                items_per_page: '条/页',  // 将 "/page" 改为 "/页"
                            }}
                            pageSizeOptions={['10', '20', '30']} // 自定义选项值
                            pageSize={limit}
                            onChange={onChangePage}
                            showLessItems={false} // 关闭"简化显示"模式
                        />
                    </div>
                </Card>
            </div>

            <CommonModal
                updateData={updateData}
                openStatus = {isModalVisible}
                closeCommonModal={closeCommonModal}
            />
            <EditCommonModal
                user={editUser}
                updateData={updateData}
                closeCommonModal={closeCommonModal}
                openStatus = {isShowEditCommon}
            />
            <EditModal
                user={editUser}
                updateData={updateData}
                closeCommonModal={closeCommonModal}
                openStatus = {isShowEdit}
            />


        </div>
    );
};

export default AppBillingManage;

